define('Components/Comein/js/views/blocks/AutocompleteFilterButtonExtensionView',[
    'backbone',
    'underscore',
    'app',
    'template!Components/Comein/templates/blocks/autocomplete-filter-button-extension',
],
function (
    Backbone,
    _,
    app,
    template) {

    return Backbone.View.extend({
        initialize:function(options){
            var view = this;
            view.render();
        },

        render: function() {
            var view = this;
            console.log('render buttonExtensionView');
            view.$el.html(template({
                isComeInTooltipVisible: view.isComeInTooltipVisible
            }))
        },

        toggleComeInTooltip: function() {
            var view = this;
            view.$el.find('.tooltip-comein').toggleClass('active', view.isComeInTooltipVisible())
        },
        isComeInTooltipVisible:function() {
            var hideComeInTooltip = false;
            try {
                hideComeInTooltip = localStorage.getItem('hideComeInTooltip');
                localStorage.setItem('hideComeInTooltip', Date.now().toString())
            }catch (e) {
                // noop
            }
            if (!hideComeInTooltip) {
                return true
            }
            var lastView = new Date(parseInt(hideComeInTooltip))
            var now = new Date()

            return !(
                lastView.getFullYear() === now.getFullYear() &&
                lastView.getMonth() === now.getMonth()
            )
        },
    });
});
